import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {FormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {BuildingSetupComponent} from './building-setup.component';
import {AngularMaterialImportModule} from '../../../../components/angular-material-import-module/angular-material-import.module';
import {FilterByPropertyPipeModule} from '../../../../pipes/filter-by-property-pipe/filter-by-property-pipe.module';
import {CommonComponentsModule} from '../../../../common-components.module';
import {NoticesModule} from '../../../notices/notices.module';
import {PdfViewerModule} from 'ng2-pdf-viewer';

@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        RouterModule,
        AngularMaterialImportModule,
        FilterByPropertyPipeModule,
        CommonComponentsModule,
        NoticesModule,
        PdfViewerModule
    ],
    exports: [
        BuildingSetupComponent
    ],
    declarations: [
        BuildingSetupComponent
    ],
    providers: [
    ],
})
export class BuildingSetupModule {
}




// WEBPACK FOOTER //
// /app/src/app/views/admin/property/building-setup/building-setup.module.ts